var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MensajeConfig } from './mensaje.config';
var Message = (function () {
    function Message() {
        this.onClick = new EventEmitter(false);
    }
    Message.prototype.showMessage = function (msg) {
        this.Msg = msg;
        this.MessageIsVisible = true;
    };
    Message.prototype.hideMsg = function (click) {
        this.MessageIsVisible = false;
        this.onClick.emit(click);
    };
    return Message;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Message.prototype, "onClick", void 0);
__decorate([
    Input(),
    __metadata("design:type", MensajeConfig)
], Message.prototype, "config", void 0);
Message = __decorate([
    Component({
        moduleId: module.id,
        selector: 'app-message',
        templateUrl: './mensaje.component.html',
    })
], Message);
export { Message };
//# sourceMappingURL=mensaje.component.js.map